import React from 'react';
import PropTypes from 'prop-types';
import { config } from '../../../Configurations';
import { generateSlugLink } from '../../../Utils';

// styled component
import { ItemWrap, ItemSymbol, ItemImageWrap, ItemImage, ItemTitle, ItemStatus } from './style';
import { HoverableLink } from '../../Layouts';

const UserBooked = props => {
    const { id, fullName } = props;
    let imageUrl = null;

    if (props.smallImage) {
        const domain = config.baseUrl;
        imageUrl = `${domain}/${props.smallImage}`;
    }

    const urlOption = {
        name: fullName,
        id,
    };

    return (
        <ItemWrap>
            <ItemSymbol>-</ItemSymbol>
            {imageUrl && (
                <ItemImageWrap>
                    <ItemImage src={imageUrl} />
                </ItemImageWrap>
            )}
            <HoverableLink to={`/${generateSlugLink(urlOption)}`}>
                <ItemTitle>{fullName}</ItemTitle>
            </HoverableLink>
            <ItemStatus>Booked in</ItemStatus>
        </ItemWrap>
    );
};

UserBooked.propTypes = {
    id: PropTypes.number,
    fullName: PropTypes.string,
    smallImage: PropTypes.string,
};

export default UserBooked;



// WEBPACK FOOTER //
// ./src/UI/Containers/BookedUsers/UserBooked.js